import { useMemo } from "react";
import { createStartPayClient } from "../core/StartPayClient";
import type { StartPayConfig } from "../types/config";
import { StartPayContext } from "./StartPayContext";

export type StartPayProviderProps = {
  config: StartPayConfig;
  children: React.ReactNode;
};

export const StartPayProvider = ({ config, children }: StartPayProviderProps) => {
  const client = useMemo(() => createStartPayClient(config), [config]);
  const value = useMemo(() => ({ client }), [client]);

  return <StartPayContext.Provider value={value}>{children}</StartPayContext.Provider>;
};
